@if (registration(); as data) {
  <section
    class="auto-reg"
    [class.auto-reg--reviewed]="!!data.reviewedAt"
    aria-label="Cadastro automático pelo Cog">
    <i class="pi pi-sparkles auto-reg__icon" aria-hidden="true"></i>
    <div class="auto-reg__body">
      <p class="auto-reg__title">
        Cadastrada automaticamente pelo Cog em {{ data.createdAt | vaultDate }}.
        @if (data.reason) {
          {{ data.reason }}{{ data.reason.trim().endsWith('.') ? '' : '.' }}
        }
      </p>

      <ul class="auto-reg__facts">
        @if (data.sourceDocument; as doc) {
          <li>
            <a
              [routerLink]="documentLinkRoute"
              [queryParams]="{ doc: doc.documentId, companyId: doc.companyId }"
              title="Abrir o documento no Data Room da empresa onde ele está">
              <i class="pi pi-file" aria-hidden="true"></i> Ver documento
            </a>
          </li>
        }
        @if (data.sourceCompany) {
          <li>Empresa de origem: {{ data.sourceCompany.name }}</li>
        }
        @if (data.requestedBy?.name) {
          <li>Pedido por: {{ data.requestedBy?.name }}</li>
        }
        @if (showNames()) {
          <li>
            Nome lido: {{ data.readCompanyName || 'não lido' }} · Nome na Receita:
            {{ data.registryCompanyName || 'não encontrado' }}
          </li>
        }
        <li>
          @if (data.economicGroup) {
            Grupo econômico: {{ data.economicGroup.name }}
          } @else {
            Não entrou em grupo econômico
          }
        </li>
      </ul>

      @if (data.overCompanyLimit) {
        <p class="auto-reg__warn">
          <i class="pi pi-exclamation-triangle" aria-hidden="true"></i>
          Com este cadastro, o cliente passou do limite de empresas do plano. Confira com o time
          comercial se a empresa deve continuar cadastrada.
        </p>
      }
    </div>

    <div class="auto-reg__actions">
      @if (data.reviewedAt) {
        <span class="auto-reg__reviewed">
          <i class="pi pi-check-circle" aria-hidden="true"></i>
          Conferida por {{ data.reviewedBy?.name || 'alguém do time' }} em
          {{ data.reviewedAt | vaultDate }}
        </span>
      } @else if (canReview()) {
        <app-button
          label="Confirmar cadastro"
          icon="check"
          size="small"
          [noMargin]="true"
          [isLoading]="reviewing()"
          [loadingText]="'Confirmando...'"
          title="Marca que alguém conferiu os dados que o Cog cadastrou"
          (sendButtonClick)="confirm()" />
      } @else {
        <span class="auto-reg__pending">A conferir</span>
      }
    </div>
  </section>
}
